import { MenuModalView } from '../../components/MenuModalView';
import { useMenuDetailStore } from '../../hooks';

export const MenuModal = () => {
  const detailStore = useMenuDetailStore();

  return <MenuModalView {...detailStore} />;
};
